module.exports = __webpack_public_path__ + "img/icon-eliminar.1253de7e.svg";